<button
  mat-icon-button
  #dateMenuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="dateMenu"
  [color]="active() ? 'primary' : ''"
  [matTooltip]="'devices.detailTabs.activity.filter.dateRange' | translate"
>
  <mat-icon>date_range</mat-icon>
</button>

<mat-menu #dateMenu="matMenu">
  <div
    class="min-w-[340px] p-4 flex flex-col gap-3"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <xemex-date-field
      [label]="'devices.detailTabs.activity.filter.initiatedOnFrom' | translate"
      [(ngModel)]="pendingFrom"
    />
    <xemex-date-field
      [label]="'devices.detailTabs.activity.filter.initiatedOnTo' | translate"
      [(ngModel)]="pendingTo"
    />

    <div class="flex gap-2 mt-1">
      <xemex-outlined-button [fullWidth]="true" class="flex-1" (click)="clear(dateMenuTrigger)">
        {{ 'general.btnClear' | translate }}
      </xemex-outlined-button>
      <xemex-filled-button [fullWidth]="true" class="flex-1" (click)="apply(dateMenuTrigger)">
        {{ 'general.btnApply' | translate }}
      </xemex-filled-button>
    </div>
  </div>
</mat-menu>
